import PropTypes from 'prop-types';
import React from 'react';
import {SVGIcon} from '@homeaway/react-svg';

/**
 * DropdownItem
 *
 */
function DropdownItem({
    link,
    dataBypass,
    text,
    svgMarkup,
    svgId,
    dropdownRole,
    ...rest
}) {
    let finalIconMarkup;

    if (svgMarkup) {
        finalIconMarkup = (
            <SVGIcon inlineFlex className="icon-color" markup={svgMarkup} />
        );
    } else if (svgId) {
        finalIconMarkup = (
            <SVGIcon inlineFlex className="icon-color" id={svgId} />
        );
    }

    if (link) {
        return (
            <li {...rest} role="presentation">
                <a
                    data-bypass={dataBypass}
                    href={link}
                    {...(dropdownRole === 'menu' && {role: 'menuitem'})}
                >
                    {finalIconMarkup} {text}
                </a>
            </li>
        );
    }

    return <li {...rest}>{text}</li>;
}

DropdownItem.propTypes = {
    /** Flag for if <a> tag needs a data-bypass attribute; for use in legacy ThinSPA apps */
    dataBypass: PropTypes.bool,
    /** URL of the DropdownItem.*/
    link: PropTypes.string,
    /** Text (or markup) to display on the DropdownItem. */
    text: PropTypes.node,
    /** For direct imports, use the SVG markup from @homeaway/svg-defs module */
    svgMarkup: PropTypes.string,
    /** ID name of SVG from an SVG Definition block, the xlink:href of the SVG you want. Used in the 'use' tag to grab it's definition from the SVG Definitions */
    svgId: PropTypes.string,
    /** A11y role, use role 'menu' to enable arrow keys navigation. */
    dropdownRole: PropTypes.string
};

DropdownItem.defaultProps = {
    dataBypass: false
};

export default DropdownItem;
